import http from "@/plugins/axios_plugin";
import { MD5 } from "crypto-js";

class ServicePedidos {
  listar(rodada_id) {
    return http.get(
      "/api/pedidos/listar?rodada_id=" + (rodada_id ? rodada_id : "0")
    );
  }

  detalharPedido(pedido_cliente_id) {
    return http.get(
      "/api/pedidos/pedidosclientes/" + pedido_cliente_id + "/listar"
    );
  }

  detalharPedidoCliente(pedido_cliente_id) {
    return http.get(
      "/api/pedidos/pedidosclientes/" + pedido_cliente_id + "/detalhar"
    );
  }

  getLojas(cliente_id) {
    return http.get("/api/relatorios/clientes/" + cliente_id + "/lojas/listar");
  }

  filtrar(filtro) {
    return http.post("/api/pedidos/filtrar", filtro);
  }

  salvar(pedido) {
    return http.post("/api/pedidos/salvar", {
      ...pedido,
      hash: MD5(JSON.stringify(pedido)).toString(),
    });
  }

  editar(pedido_id, uuid) {
    return http.get("/api/pedidos/" + pedido_id + "/editar", {
      headers: { uuid },
    });
  }

  atualizar(pedido_id, pedido) {
    return http.post("/api/pedidos/" + pedido_id + "/atualizar", {
      ...pedido,
      hash: MD5(JSON.stringify(pedido)).toString(),
    });
  }

  cancelarPedido(pedido_id) {
    return http.post("/api/pedidos/" + pedido_id + "/cancelar");
  }

  cancelarPedidoCliente(pedido_cliente_id) {
    return http.post(
      "/api/pedidos/pedidosclientes/" + pedido_cliente_id + "/cancelar"
    );
  }

  fechar(pedido) {
    return http.post("/api/pedidos/ " + pedido.id + "/fechar", pedido);
  }

  entregarPedidoCliente(pedido_cliente_id) {
    return http.post(
      "/api/pedidos/pedidosclientes/" + pedido_cliente_id + "/entregar"
    );
  }

  entregarPedido(pedido_id) {
    return http.post("/api/pedidos/" + pedido_id + "/entregar");
  }

  desfazerEntrega(pedido_id) {
    return http.post("/api/pedidos/" + pedido_id + "/entregar/desfazer");
  }

  getClientes(rodada_id, id, busca) {
    return http.get(
      "/api/pedidos/clientes?rodada_id=" +
        rodada_id +
        (id ? "&id=" + id : "") +
        (busca ? "&busca=" + busca : "")
    );
  }

  getFornecedores(rodada_id) {
    return http.get("/api/pedidos/fornecedores?rodada_id=" + rodada_id);
  }

  getRepresentantes(rodada_id) {
    return http.get("/api/pedidos/representantes?rodada_id=" + rodada_id);
  }

  getProdutos(busca) {
    return http.get("/api/pedidos/produtos?busca=" + busca);
  }

  getProdutoCodigo(codigo) {
    return http.get("/api/pedidos/produtos/codigo?codigo=" + codigo);
  }

  getDataAtual() {
    return http.get("/api/pedidos/data");
  }

  salvarPedidoCliente(pedido) {
    return http.post("/api/pedidos/salvar/cliente", pedido);
  }

  carregarPedidosAbertos(cliente_id, rodada_id) {
    return http.get(
      `/api/pedidos/abertos?cliente_id=${cliente_id}&rodada_id=${rodada_id}`
    );
  }

  imprimir(pedido_id) {
    return http.get("/api/pedidos/" + pedido_id + "/imprimir");
  }
}

export default new ServicePedidos();
